import {environment} from "../../../../environments/environment";

function createUrl(actionName: string): string {
  return `${environment.apiBaseUrl}${environment.apiUrl}${environment.apiVersion}${actionName}`;
}

export const TaskApiResources = {
  list:  createUrl('tasks'),
  search:  createUrl('tasks/search'),
  create:  createUrl('tasks/create'),
  copy: createUrl('tasks'),
  updateStatus:  createUrl('tasks/change-status'),
  detail:  createUrl('tasks'),
  update:  createUrl('tasks'),
  delete:  createUrl('tasks'),
  deleteMultiple:  createUrl('tasks/delete/multiple'),
  deleteAvailability:  createUrl('tasks/delete/availability'),
  taskSearch: createUrl('tasks/search-reference-numbers'),
  taskStatuses: createUrl('statuses/task'),
  pendingCount: createUrl('tasks/pending/count'),
};
